import React, { useEffect } from 'react';
import './Theme.css';
import { getUrlParams } from '../apiService/timespam';
import CognitiveAgeCard from '../Components/Games/CognitiveAgeCard';

// Standalone page for the Cognitive Age card, so it can be linked to /
// embedded on its own (outside the games list) wherever it's needed.
const CognitiveAge = () => {
  const { theme, lang } = getUrlParams();

  useEffect(() => {
    document.documentElement.className = theme === 'dark' ? 'dark' : '';
    if (lang === 'ar') document.documentElement.dir = 'rtl';
  }, [theme, lang]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg-page)',
        padding: 16,
        boxSizing: 'border-box',
      }}
    >
      <CognitiveAgeCard />
    </div>
  );
};

export default CognitiveAge;
